import { useMemo } from "react";

export type Platform = "ios" | "android";

export type InAppContext = {
    isInApp: boolean;
    userAgent: string;
    platform: Platform | null;
};

const androidBrowserIndicators = ["android 10;", ".0.0.0"];

export const useInAppBrowser = (): InAppContext => {
    return useMemo(() => {
        const userAgent = navigator.userAgent || "";
        const ua = userAgent.toLowerCase();

        const isIOS = /iphone|ipad|ipod/.test(ua);
        const isAndroid = /android/.test(ua);

        let platform: Platform | null = null;
        if (isIOS) platform = "ios";
        if (isAndroid) platform = "android";

        if (platform === "ios") {
            const isInApp = !("serviceWorker" in navigator);

            return { isInApp, platform, userAgent };
        }

        if (platform === "android") {
            const isInApp = !androidBrowserIndicators.some((i) =>
                ua.includes(i),
            );

            return { isInApp, platform, userAgent };
        }

        return { isInApp: false, platform, userAgent };
    }, []);
};
